import React from "react";
import CampaignCountdown from "./CampaignCountdown";
import {CustomTooltip} from "components/CustomTooltip";
import {IconNotificationCircle} from "components/icons";
import {t} from "i18next";

//page effects
import Snowfall from "react-snowfall";

const CustomCampaign = ({
  show,
  endDate,
  tooltipTextKey,
  textKey,
  detailsKey,
  backgroundColor,
  textColor,
  iconColor,
  pageEffect,
}) => {
  const currentDate = new Date();
  const endDateTime = new Date(endDate);

  if (currentDate > endDateTime || !show) return null;

  const campaignStyle = {backgroundColor: backgroundColor, color: textColor};
  const snowfallStyle = {position: "fixed", width: "100vw", height: "100vh"};

  return (
    <>
      {pageEffect === "snowfall" && <Snowfall style={snowfallStyle} />}
      <div className="custom-campaign" style={campaignStyle}>
        {t(textKey)}
        <CampaignCountdown targetDate={endDate} addClass="ml-4" />
        <CustomTooltip text={t(tooltipTextKey)}>
          <span className="info ml-4 df-row-center">
            <IconNotificationCircle color={iconColor || textColor} />{" "}
            <span className="ml-1">{t(detailsKey)}</span>
          </span>
        </CustomTooltip>
      </div>
    </>
  );
};

export default CustomCampaign;
